import { render, staticRenderFns } from "./accountsPayable.vue?vue&type=template&id=372fff9e&scoped=true"
import script from "./accountsPayable.vue?vue&type=script&lang=js"
export * from "./accountsPayable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372fff9e",
  null
  
)

export default component.exports